import { render } from "./MobileNotificationsBell.vue?vue&type=template&id=55aebb6c&scoped=true"
import script from "./MobileNotificationsBell.vue?vue&type=script&lang=js"
export * from "./MobileNotificationsBell.vue?vue&type=script&lang=js"

import "./MobileNotificationsBell.vue?vue&type=style&index=0&id=55aebb6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55aebb6c"]])

export default __exports__